Vue.directive('loading-fullscreen', {
    bind(el, binding, vNode){
        if(binding.value){
            let status = true;
            for (let index = 0; index < el.children.length; index++) {
                if(el.children[index].className == 'ldc-loading-fullscreen'){
                    status = false;
                    return;
                }
            }
            if(status){
                let body = document.querySelector('body');
                body.insertAdjacentHTML('beforeend', divLoading(Vue.prototype.$textLoadingFull));
                Vue.prototype.$overflowHidenBody();
            }
        }
    },
    update(el,binding, vNode){
        if(binding.value){
            let status = true;
            for (let index = 0; index < el.children.length; index++) {
                if(el.children[index].className == 'ldc-loading-fullscreen'){
                    status = false;
                    return;
                }
            }
            if(status){
                let body = document.querySelector('body');
                body.insertAdjacentHTML('beforeend', divLoading(Vue.prototype.$textLoadingFull));
                Vue.prototype.$overflowHidenBody();
            }
            
        }else{
            let dom = document.querySelectorAll('.ldc-loading-fullscreen')
            for (let index = 0; index < dom.length; index++) {
                dom[index].remove();
            }
            Vue.prototype.$removeOverflowHidenBody();
        }
    }
});

let divLoading = (text) => {
    return `<div class="ldc-loading-fullscreen">
        <div class="center-loading">
            <div class="cricle-loading">
                <span class="cricle-loading__title">
                    ${text}
                </span>
                <div class="cricle-loading__item"></div>
            </div>
        </div>
    </div>`
};